import PropTypes from 'prop-types';
import { Box, Card, Chip, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { format } from 'date-fns';

const buildSummaryItems = ({ totalBuilds, pastDueCount, openQuestionCount }) => [
  {
    label: 'Active Builds',
    value: totalBuilds,
    tone: 'info',
    background: '#dbeafe',
  },
  {
    label: 'Past Due',
    value: pastDueCount,
    tone: 'error',
    background: '#fee2e2',
  },
  {
    label: 'Open Questions',
    value: openQuestionCount,
    tone: 'warning',
    background: '#ffedd5',
  },
  // {
  //   label: 'Refresh In',
  //   value: `${secondsToRefresh}s`,
  //   tone: 'secondary',
  //   background: '#e0f2fe',
  // },
];

const FloorDisplayHeader = ({
  now,
  lastUpdatedAt,
  // refreshIntervalMs,
  totalBuilds,
  pastDueCount,
  openQuestionCount,
}) => {
  // const elapsedMs = Math.max(0, now.getTime() - lastUpdatedAt.getTime());
  // const secondsToRefresh = Math.max(
  //   0,
  //   Math.ceil(((refreshIntervalMs - (elapsedMs % refreshIntervalMs)) % refreshIntervalMs) / 1000) ||
  //   Math.round(refreshIntervalMs / 1000)
  // );
  const summaryItems = buildSummaryItems({
    totalBuilds,
    pastDueCount,
    openQuestionCount,
    // secondsToRefresh,
  });

  return (
    <Stack spacing={1.5} sx={{ mb: 1.5 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 2.5 },
          borderRadius: 3,
          border: '1px solid rgba(148, 163, 184, 0.24)',
          background:
            'linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(245,249,255,0.92) 100%)',
          boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', lg: 'center' }}
        >
          <Stack spacing={1.2}>
            <Stack direction="row" spacing={1.2} alignItems="center" flexWrap="wrap">
              <Typography variant="h4">
                Build Board
              </Typography>
            </Stack>

            <Typography variant="body2" >
              Live board for active builds, sorted by anticipated completion date. Open contractor
              questions are surfaced first for immediate shop follow-up.
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Chip
                label={`Last refreshed ${format(lastUpdatedAt, 'hh:mm a')}`}
                sx={{
                  fontWeight: 700,
                  bgcolor: alpha('#4d66cc', 0.1),
                  color: '#3147a8',
                  '&:hover': {
                    bgcolor: alpha('#4d66cc', 0.1),
                  },
                  // If using MUI v5 with clickable chip, also disable the ripple effect
                  cursor: 'default',
                  pointerEvents: 'none', // remove this if the chip needs to be interactive
                }}
              />
            </Stack>
          </Stack>

          <Box
            sx={{
              textAlign: { xs: 'left', lg: 'right' },
              minWidth: { lg: 280 },
            }}
          >
            <Typography
              variant="h4"
            >
              {format(now, 'hh:mm a')}
            </Typography>
            <Typography
              sx={{
                mt: 0.5,
                fontSize: { xs: '0.92rem', md: '1rem' },
                color: '#64748b',
                letterSpacing: '0.02em',
              }}
            >
              {format(now, 'EEEE, MMMM d, yyyy')}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' },
          gap: 1.5,
        }}
      >
        {summaryItems.map((item) => (
          <ShopCard
            title={item.label}
            color={item.tone}
            total={item.value}
            icon="/assets/icons/navbar/ic_list.svg"
          />
        ))}
      </Box>
    </Stack>
  );
};

FloorDisplayHeader.propTypes = {
  now: PropTypes.instanceOf(Date).isRequired,
  lastUpdatedAt: PropTypes.instanceOf(Date).isRequired,
  refreshIntervalMs: PropTypes.number.isRequired,
  totalBuilds: PropTypes.number.isRequired,
  pastDueCount: PropTypes.number.isRequired,
  openQuestionCount: PropTypes.number.isRequired,
};

export default FloorDisplayHeader;

function ShopCard({ title, total, currency }) {
  return (
    <Card sx={{ py: 2, pl: 3, pr: 2.5 }} >
      <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography noWrap variant="subtitle2" component="div" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>
        <Box sx={{ typography: 'h4' }}>{`${currency ?? ''}${(total)}`}</Box>
      </Box>

    </Card>
  )
}
